import Reveal from "./Reveal";

export default function Testimonials() {
  return (
    <section
      id="reviews"
      data-testid="testimonials-section"
      className="overflow-hidden py-24 lg:py-36"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <Reveal>
          <p className="eyebrow">Kind words</p>

          <h2 className="mt-4 max-w-2xl font-serif text-4xl tracking-tight text-ink sm:text-5xl">
            What our neighbours{" "}
            <span className="italic text-ocean">say about us</span>
          </h2>

          <p className="mt-4 max-w-2xl text-sm text-slateblue/70">
            See what our customers are saying about Rock Coast Cleaning.
          </p>
        </Reveal>
      </div>

      <div className="mx-auto mt-14 max-w-7xl px-6 lg:px-12">
        <div
          className="elfsight-app-9ae81744-cb12-4f9b-8ced-c531aaca81d3"
          data-elfsight-app-lazy
        ></div>
      </div>
    </section>
  );
}
